__turbopack_context__.v({
  "container": "tBY5Ia_container",
  "isActive": "tBY5Ia_isActive",
  "isDisabled": "tBY5Ia_isDisabled",
  "slide": "tBY5Ia_slide",
  "tab": "tBY5Ia_tab",
});
